/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

import StatusTracking from '../../../common/StatusTracking';

const OrderTracking = ({ ROSSStatus, ROSSOrderPendingCancel, IsPendingCancelEnabled }) => {
   return (
      <StatusTracking ROSSStatus={ROSSStatus} ROSSOrderPendingCancel={ROSSOrderPendingCancel} IsPendingCancelEnabled={IsPendingCancelEnabled} />
   )
};

OrderTracking.defaultProps = {
    ROSSStatus: '',
    ROSSOrderPendingCancel: false,
    IsPendingCancelEnabled: false,
};

OrderTracking.propTypes = {
    ROSSStatus: PropTypes.string,
    ROSSOrderPendingCancel: PropTypes.bool,
    IsPendingCancelEnabled: PropTypes.bool,
};

export default OrderTracking;
